function buildMerchantExpireParams(productId, now = Date.now) {
  return {
    product_id: productId,
    _t: now(),
  }
}

function readMerchantExpired(response) {
  return Boolean(response && response.data && response.data.expired)
}

module.exports = { buildMerchantExpireParams, readMerchantExpired }
